import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MakingTecaPost, MakingTecaPostData } from '../../../../shared/interface';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-modifica-making-teca-backoffice',
  templateUrl: './modifica-making-teca-backoffice.component.html',
  styleUrl: './modifica-making-teca-backoffice.component.css'
})
export class ModificaMakingTecaBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private confirmationService: ConfirmationService) { }

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  formPost!: FormGroup;

  tipi: { tipo: string }[] = [
    { tipo: 'Operatore' },
    { tipo: 'Amministratore' }
  ]

  immagineBox: File | null = null
  immaginiContent: File[] | null = []

  making_teca_post?: MakingTecaPost;
  making_teca_post_data: MakingTecaPostData[] = []

  show_image: boolean = false;

  ngOnInit(): void {

    this.formPost = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      data: new FormControl(null, Validators.required),
      immagine: new FormControl(null, Validators.required)
    })


    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getMakingTecaPost(id).subscribe({
        next: (data) => this.making_teca_post = data,
        error: (err) => this.router.navigate(['/backoffice/making-teca']),
        complete: () => {

          this.formPost.patchValue({
            titolo: this.making_teca_post?.titolo,
            data: new Date(this.making_teca_post!.data),
            immagine: this.making_teca_post?.immagine
          })

          this.apiService.getMakingTecaPostData(id).subscribe({
            next: (data) => this.making_teca_post_data = [...data],
            error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
            complete: () => {

              this.making_teca_post_data.map((data, index) => {

                this.formPost.addControl('titolo_' + index, new FormControl(null))
                this.formPost.addControl('descrizione_' + index, new FormControl(null))
                this.formPost.addControl('immagine_' + index, new FormControl(null))

                this.formPost.patchValue({
                  ['titolo_' + index]: data.titolo,
                  ['descrizione_' + index]: data.descrizione,
                  ['immagine_' + index]: data.immagine,
                })
              })


            }
          })


        }
      })


    })

  }

  onImmagineUpload(file: any) {
    let image = file.currentFiles[0];

    this.formPost.patchValue({ immagine: image.name });

    const isJpgOrPng = image.type === 'image/jpeg' || image.type === 'image/png';
    if (isJpgOrPng) {
      this.immagineBox = image;
    }
  };

  onRemoveImmagineUpload(file: any) {
    this.immagineBox = null
    this.formPost.patchValue({ immagine: '' });
  }

  onImmagineContenutoUpload(file: any, i: number) {
    let image = file.currentFiles[0]
    this.formPost.patchValue({ ["immagine_" + i]: image.name });

    const isJpgOrPng = image.type === 'image/jpeg' || image.type === 'image/png';
    if (isJpgOrPng) {
      this.immaginiContent?.push(image);
    }
  };

  onRemoveImmagineContenutoUpload(file: any, i: number) {
    this.immaginiContent?.splice(i, 1)
    this.formPost.patchValue({ ["immagine_" + i]: '' });
  }

  onAddContenuto() {

    this.making_teca_post_data.push({
      id: this.making_teca_post_data[this.making_teca_post_data.length - 1].id + 1,
      id_post: this.making_teca_post!.id,
      titolo: '',
      descrizione: '',
      immagine: '',
      data_creazione: new Date(),
      data_aggiornamento: new Date()
    })

    this.making_teca_post_data.map((data, index) => {
      this.formPost.addControl('titolo_' + index, new FormControl(null))
      this.formPost.addControl('descrizione_' + index, new FormControl(null))
      this.formPost.addControl('immagine_' + index, new FormControl(null))
    })

  }

  onRemoveContenuto(index: number) {
    this.making_teca_post_data.splice(index, 1);

    this.formPost.removeControl('titolo_' + index)
    this.formPost.removeControl('descrizione_' + index)
    this.formPost.removeControl('immagine_' + index)
  }

  onDeletePostPopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il post?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteMakingTecaPost(this.making_teca_post!.id).subscribe({
          next: (data) => this.apiService.setMakingTecaPosts(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/making-teca']);
            this.apiService.message("success", "Eliminazione", "Il post è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }


  onSubmit() {

    const formData = new FormData();
    formData.append('image', this.immagineBox || '');
    formData.append('titolo', this.formPost.get('titolo')?.value);
    formData.append('data', this.datePipe.transform(this.formPost.get('data')?.value, 'yyyy-MM-dd') || '');
    formData.append('content', JSON.stringify(this.making_teca_post_data));

    this.apiService.updateMakingTecaPost(formData, this.making_teca_post!.id).subscribe({
      next: (data) => this.apiService.setMakingTecaPosts(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        if (this.making_teca_post_data.length > 0) {

          this.making_teca_post_data.map((data, index) => {

            const titolo = this.formPost.get('titolo_' + index)?.value || '';
            const descrizione = this.formPost.get('descrizione_' + index)?.value || '';

            if (titolo.length > 0) {

              const formPostData = new FormData();
              formPostData.append('image', this.immaginiContent![index] || '');
              formPostData.append('titolo', titolo);
              formPostData.append('descrizione', descrizione);
              formPostData.append('id_post', this.making_teca_post!.id.toString())

              this.apiService.updateMakingTecaPostData(formPostData, data.id).subscribe({
                next: (data) => this.apiService.setMakingTecaPosts(),
                error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                complete: () => {

                  if (index == this.making_teca_post_data.length - 1) {
                    this.router.navigate(['/backoffice/making-teca'])
                    this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
                  }

                }
              })
            }

          })
        } else {
          this.router.navigate(['/backoffice/making-teca'])
          this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
        }
      }
    })


  }

}
